import styled from "styled-components";
import NoSearchResultIconSvg from "@local/icons/component/NoSearchResultIcon";

export const StyledNoSearchResultIconSvg = styled(NoSearchResultIconSvg)`
  width: 128px;
  height: 129px;
`;

export const NoSearchResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 64px;
`;

export const Container = styled.div`
	display: flex;
  	flex-direction: column;
	text-align: center;
	margin: 0 auto;
	align-items: center;
	margin-top: 80px;
	
	h1 {
		display: inline-block;
		margin: 8px 0;
		text-align: center;
	}

	span {
		font-size: 16px;
	}
`;


